<template>
  <div class="external-score-entry">
    <el-dialog
      :visible.sync="externalScoreEditShow"
      width="800px"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div class="title" slog="title">
        <span>校外成绩修改(平均分)</span>
        <i class="icon el-icon-circle-plus-outline" @click="addData"></i>
        <i class="icon el-icon-remove-outline" @click="delData"></i>
      </div>
      <div class="score-entry-dialog">
        <el-form ref="form" label-width="80px">
          <el-form-item>
            校外标识
            <el-input
              class="campus-sign"
              placeholder="请输入校外标识"
              v-model="editItemInfo.outsideSchoolSign"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            v-for="(item, index) in editItemInfo.scoreInfoList"
            :key="index"
            :inline="true"
            :model="item"
            v-if="item.delFlag == '0'"
          >
            <el-col :span="10">
              <span style="width: 50px; margin-right: 5px">科目</span>
              <el-select
                v-model="item.courseId"
                placeholder="请选择"
                @change="courseChange"
              >
                <el-option
                  v-for="sItem in schoolCourseList"
                  :key="sItem.courseId"
                  :label="sItem.courseName"
                  :value="sItem.courseId"
                  :disabled="sItem.disabled"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="11" style="display: flex">
              <span style="width: 50px; margin-right: 5px">平均分</span>
              <el-input
                v-model.number="item.avgScore"
                placeholder="请输入"
                prop="rank"
                type="number"
                :min="1"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list">
        <div class="btn define" @click="confirm">确定</div>
        <div class="btn cancel" @click="dialogClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["externalScoreEditShow", "editItemData", "schoolCourseList"],
  data() {
    return {
      dataList: [
        {
          subjectName: "",
          averageScore: "",
        },
      ],
      editItemInfo: {},
    };
  },
  created() {
    // this.editItemInfo = this.editItemData;
  },
  methods: {
    courseChange(e) {
      // console.log(e);
      this.schoolCourseList.forEach((item) => {
        if (
          this.editItemInfo.scoreInfoList.find(
            (dItem) => dItem.courseId == item.courseId
          )
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    dialogOpen() {
      this.editItemInfo = this.editItemData;
      this.dataList = JSON.parse(
        JSON.stringify(this.editItemInfo.scoreInfoList)
      );

      this.schoolCourseList.forEach((item) => {
        if (this.dataList.find((dItem) => dItem.courseId == item.courseId)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      // console.log(this.editItemInfo);
    },
    // 校外成绩修改点击确定
    confirm() {
      // console.log("校外成绩修改点击确定");
      let data = [];

      this.editItemInfo.scoreInfoList.forEach((item) => {
        data.push({
          id: item.id,
          schoolId: this.editItemInfo.schoolId,
          gradeId: this.editItemInfo.gradeId,
          examInfoId: this.editItemInfo.examInfoId,
          courseId: item.courseId,
          avgScore: item.avgScore,
          outsideSchoolSign: this.editItemInfo.outsideSchoolSign,
          delFlag: item.delFlag,
        });
      });
      // console.log("data:", data);
      this.$emit("externalScoreEditConfirm", data);
    },
    // 关闭弹出窗口
    dialogClose() {
      // this.dataList = [
      //   {
      //     courseName: "",
      //     avgScore: "",
      //   },
      // ];
      this.$emit("update:externalScoreEditShow", false);
    },
    // 添加一行数据
    addData() {
      this.editItemInfo.scoreInfoList.push({
        courseName: "",
        avgScore: "",
        delFlag: "0",
      });
      this.dataList.push({
        courseName: "",
        avgScore: "",
        delFlag: "0",
      });
    },
    // 删除一行数据
    delData() {
      if (this.dataList.length == 1)
        return this.$message.warning("至少存在一条数据！");
      this.dataList.pop();
      this.editItemInfo.scoreInfoList[this.dataList.length].delFlag = "1";

      this.schoolCourseList.forEach((item) => {
        if (this.dataList.find((dItem) => dItem.courseId == item.courseId)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./externalScoreEditDialog.scss";
</style>